import React, { FC } from 'react';
import { ContactUs } from './contact-us';

import {
  MailOutline,
  PhoneOutlined,
  LocationOnOutlined,
  HeadsetMicOutlined,
  BusinessOutlined
} from "@mui/icons-material";

export const ContactUsContainer: FC = () => {

  const contactItems = [
    {
      icon: <MailOutline />,
      label: 'Email',
      value: 'ouvidoria@es.gov.br',
    },
    {
      icon: <PhoneOutlined />,
      label: 'Telefone',
      value: '0800 022 11 17',
    },
    {
      icon: <HeadsetMicOutlined />,
      label: 'Atendimento Online',
      value: '9h às 17h',
    },
    {
      icon: <LocationOnOutlined />,
      label: 'Endereço',
      value: 'Edifício Aureliano Hoffman, 10º andar. Av. João Batista Parra, nº 600, Enseada do Suá, Vitória – ES, CEP: 29050-375 29050-375, Vitória - ES',
    },
    {
      icon: <BusinessOutlined />,
      label: 'Atendimento Presencial',
      value: '10h às 16h',
    },
  ];

  return (
    <div>
      <ContactUs items={contactItems} />
    </div>
  );
};